<template>
    <div>
        <div class="page-content">
            <Filters />
            <SearchListing />
        </div>
        <ModalAddToNewWatchlist />
        <LiveEventNotification :eventStatus="liveEventStatus" :course="liveEventCourse" />
    </div>
</template>

<script>
    import Filters from 'components/searchable-listing/Filters'
    import SearchListing from 'components/searchable-listing/Listing'
    import { mapGetters } from 'vuex'
    import ModalAddToNewWatchlist from 'components/shared/modals/ModalAddToNewWatchlist'
    import loadingOverlay from 'components/shared/mixins/loadingOverlay'
    import LiveEventNotification from 'components/layout/LiveEventNotification'

    export default {
        name: 'course-list-page',
        components: {
            Filters,
            SearchListing,
            ModalAddToNewWatchlist,
            LiveEventNotification
        },
        mixins: [ loadingOverlay ],
        computed: {
            ...mapGetters({
                getMenuItemBySlug: 'Menu/getMenuItemBySlug',
                courseList: 'Courses/getCoursesList',
                isLoggedIn: 'isLoggedIn',
                getSearchPhrase: 'CourseFilter/getSearchPhrase',
                getCourseWithLiveEvent: 'Courses/getCourseWithLiveEvent',
                listItemType: 'CourseFilter/getListItemType'
            }),
            collectionsWithCourses () {
                return this.collectionsList.filter(collection => collection.items.length > 0)
            },
            routePackage () {
                return this.$route.params.packageSlug
            },
            liveEventStatus () {
                if (this.getCourseWithLiveEvent !== null) {
                    return this.getCourseWithLiveEvent.status
                }
                return null
            },
            liveEventCourse () {
                if (this.getCourseWithLiveEvent !== null) {
                    return this.getCourseWithLiveEvent.course
                }
                return null
            }
        },
        methods: {
            onListChange (newList) {
                this.limitedCollection = newList
            },
            onClearFilters () {
                this.search = ''
            },
            async refreshPackage () {
                const loaderKey = 'loading-courses'
                try {
                    if (this.$route.params.packageSlug) {
                        await this.$store.dispatch('Courses/loadCourseWithLiveEvent')
                        this.checkLiveEventNotification()
                    }
                } catch (e) {
                    this.$store.dispatch('LoaderScreen/removeTaskFromLoader', loaderKey)
                    if (e.code === 404 || e.response.status === 404) {
                        this.$router.push({ name: 'page-not-found' })
                    }

                    if (e.code === 403 || e.response.status === 403) {
                        this.$router.push({ name: 'page-no-permission' })
                    }
                    throw e
                }
            },
            checkLiveEventNotification () {
                this.checkingLiveEvent = setInterval(() => {
                    this.$store.dispatch('Courses/loadCourseWithLiveEvent')
                }, 15000)
            }
        },
        watch: {
            routePackage: {
                handler: 'refreshPackage',
            },
            isLoggedIn: {
                handler: 'refreshPackage',
                immediate: true
            }
        },
        data () {
            return {
                limitedCollection: [],
                search: '',
                checkingLiveEvent: null
            }
        },
        created () {
            this.$store.dispatch('Search/enableSearch')
            if (this.getSearchPhrase && this.getSearchPhrase.id === this.routePackage) {
                this.search = this.getSearchPhrase.text
            }

            this.$store.dispatch('Search/setMainPackage', this.$route.params.packageSlug)
        },
        beforeDestroy () {
            this.$store.dispatch('Watchlists/closeMenu')
            this.$store.dispatch('CourseFilter/assignSearchPhrase', { id: this.routePackage, text: this.search })
            this.$store.dispatch('Courses/clearCourseWithLiveEvent')
            clearInterval(this.checkingLiveEvent)
        }
    }
</script>
